<template>
  <div class="post">
    <div v-for="post in posts">
      <div class="my-4 border-bottom pb-3">
        <h2 class="display-4" v-html="post.title.rendered">{{ post.title.rendered }}</h2>
        <ul class="list-inline text-muted mt-3">
          <li class="list-inline-item mr-3">
            <i class="fas fa-calendar-day mr-1"></i>
            {{ post.date | moment("dddd, MMMM D, YYYY") }}
          </li>
          <li class="list-inline-item mr-3">
            <i class="fas fa-clock mr-1"></i>
            {{ post.date | moment("h:mm a") }}
          </li>
          <li class="list-inline-item mr-3">
            <i class="fas fa-user-circle mr-1"></i>
            ShareNote.com Team
          </li>
        </ul>
      </div>

      <div class="row mb-4">
        <div class="col-md-8">
          <PostImage v-bind:mediaid="post.featured_media" v-bind:postimageurl="post.jetpack_featured_media_url" />
          <div class="sn-c-post mt-3">
            <div v-html="post.content.rendered">
              {{ post.content.rendered }}
            </div>

            <div style="display:none;">
              <hr>

              <div class="row">
                <div class="col-sm-6">
                  <a href="#" class="btn btn-link"><i class="fas fa-arrow-left mr-3"></i>Title of Previous Post</a>
                </div>
                <div class="col-sm-6 text-right">
                  <a href="#" class="btn btn-link">Title of Next Post<i class="fas fa-arrow-right ml-3"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 d-none d-md-block">
          <NewsletterSignUp />
          <SearchForm />
          <CardShareNoteNews />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import NewsletterSignUp from '@/components/NewsletterSignUp.vue';
import SearchForm from '@/components/SearchForm.vue';
import CardShareNoteNews from '@/components/CardShareNoteNews.vue';
import PostImage from '@/components/PostImage.vue';

export default {
  title: 'ShareNote.com Support Center - Post View',
  name: 'home',
  components: {
    NewsletterSignUp,
    SearchForm,
    CardShareNoteNews,
    PostImage
  },
  data() {
    return {
      posts: [],
      errors: []
    }
  },
  watch: {
    '$route': 'getPost'
  },
  methods: {
    getPost() {
      axios.get('https://wpapi.sharenote.com/wp-json/wp/v2/posts?slug=' + this.$route.params.slug)
        .then(response => {
          this.posts = response.data;
        })
        .catch(err => console.error(err));
    }
  },
  created() {
    this.getPost();
  }
}
</script>
